import React from 'react';
import {Navigate, Routes, Route} from 'react-router-dom';

import {Chat} from './pages/Chat';
import {Home} from './pages/Home/Home';
import Private from './templates/Private';
import Public from './templates/Public';

const Switch = () => (
  <Routes>
    <Route
      path="/chat"
      element={
        <Private>
          <Chat />
        </Private>
      }
    />
    <Route
      path="/"
      element={
        <Public>
          <Home />
        </Public>
      }
    />
    <Route path="*" element={<Navigate to={{pathname: '/'}} />} />
  </Routes>
);

export default Switch;
